import React, { useState } from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import Fieldset from "../../Components/FieldSet";

// --- Theme Data ---
const themes = [
  {
    name: "Default",
    colors: ["#1F2937", "#3B82F6", "#60A5FA", "#D1D5DB"], // Dark Blue/Gray Palette
  },
  {
    name: "Light",
    colors: ["#E5E7EB", "#9CA3AF", "#F97316", "#06B6D4"], // Gray/Orange/Cyan Palette
  },
  {
    name: "Modern",
    colors: ["#000000", "#3B82F6", "#10B981", "#EAB308"], // Black/Blue/Green/Yellow Palette
  },
  {
    name: "80's Kid",
    colors: ["#083F8C", "#1D4ED8", "#EC4899", "#F97316"], // Deep Blue/Pink/Orange Palette
  },
];

// --- Color Palette Block Component ---
const ColorPalette = ({ colors }) => (
  <div
    className="d-flex w-100"
    style={{ height: "20px", borderRadius: "8px", overflow: "hidden" }}
  >
    {colors.map((color, index) => (
      <div key={index} style={{ backgroundColor: color, flex: 1 }} />
    ))}
  </div>
);

// --- Main Selector Component ---
const ColorThemeSelector = ({ onThemeChange }) => {
  const [selectedTheme, setSelectedTheme] = useState("Default");

  const handleChange = (themeName) => {
    setSelectedTheme(themeName);
    if (onThemeChange) {
      onThemeChange(themeName);
    }
  };

  return (
    <Fieldset legend="Adjust Colors " className="p-4 shadow-sm w-100">
      <Row className="gy-3">
        {themes.map((theme) => (
          <Col xs={12} md={6} lg={4} key={theme.name}>
            <Form.Check
              type="radio"
              id={theme.name}
              name="colorTheme"
              label={theme.name}
              checked={selectedTheme === theme.name}
              onChange={() => handleChange(theme.name)}
            />
            <ColorPalette colors={theme.colors} />
          </Col>
        ))}
      </Row>

      {/* <div className="mt-3 p-2 border rounded bg-light text-primary small">
        Current Theme Selected: <strong>{selectedTheme}</strong>
      </div> */}
    </Fieldset>
  );
};

export default ColorThemeSelector;
